const getPosition = (arrow: string) => {
  let props;

  switch (arrow) {
    case 'bottom-center':
      props = {
        anchorOrigin: { horizontal: 'center', vertical: 'top' },
        style: {},
        transformOrigin: { horizontal: 'center', vertical: 'bottom' },
      };
      break;
    case 'bottom-left':
      props = {
        anchorOrigin: { horizontal: 'left', vertical: 'top' },
        style: { ml: -0.75 },
        transformOrigin: { horizontal: 'left', vertical: 'bottom' },
      };
      break;
    case 'bottom-right':
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        style: { ml: 0.75 },
        transformOrigin: { horizontal: 'right', vertical: 'bottom' },
      };
      break;
    case 'left-bottom':
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        style: { mt: 0.75 },
        transformOrigin: { horizontal: 'left', vertical: 'bottom' },
      };
      break;
    case 'left-center':
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'center' },
        transformOrigin: { horizontal: 'left', vertical: 'center' },
      };
      break;
    case 'left-top':
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'top' },
        style: { mt: -0.75 },
        transformOrigin: { horizontal: 'left', vertical: 'top' },
      };
      break;
    case 'right-bottom':
      props = {
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        style: { mt: 0.75 },
        transformOrigin: { horizontal: 'right', vertical: 'bottom' },
      };
      break;
    case 'right-center':
      props = {
        anchorOrigin: { horizontal: 'left', vertical: 'center' },
        transformOrigin: { horizontal: 'right', vertical: 'center' },
      };
      break;
    case 'right-top':
      props = {
        anchorOrigin: { horizontal: 'left', vertical: 'top' },
        style: { mt: -0.75 },
        transformOrigin: { horizontal: 'right', vertical: 'top' },
      };
      break;
    case 'top-center':
      props = {
        anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
        style: {},
        transformOrigin: { horizontal: 'center', vertical: 'top' },
      };
      break;
    case 'top-left':
      props = {
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        style: { ml: -0.75 },
        transformOrigin: { horizontal: 'left', vertical: 'top' },
      };
      break;
    case 'top-right':
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        style: { ml: 0.75 },
        transformOrigin: { horizontal: 'right', vertical: 'top' },
      };
      break;

    // top-right
    default:
      props = {
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        style: { ml: 0.75 },
        transformOrigin: { horizontal: 'right', vertical: 'top' },
      };
  }

  return props;
};

export default getPosition;
